
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_1oo3v_103",
  "arrow": "awsui_arrow_18eso_1oo3v_103",
  "has-caret": "awsui_has-caret_18eso_1oo3v_170",
  "placeholder": "awsui_placeholder_18eso_1oo3v_173",
  "pressed": "awsui_pressed_18eso_1oo3v_186",
  "disabled": "awsui_disabled_18eso_1oo3v_189",
  "in-filtering-token": "awsui_in-filtering-token_18eso_1oo3v_199",
  "read-only": "awsui_read-only_18eso_1oo3v_205",
  "invalid": "awsui_invalid_18eso_1oo3v_227",
  "inline-tokens": "awsui_inline-tokens_18eso_1oo3v_265"
};
  